<template>
  <DialogContent class="flex flex-col items-center">
    <Icon
      id="scaling-stroke"
      name="FilledCircleCheck"
      :size="48"
      class="mt-6 mb-[18px]"
    />
    <div class="font-semibold font-primary text-[17px] leading-[24px]">
      {{ props.title }}
    </div>
    <div
      v-if="props.html"
      v-html="sanitizedHtml"
      class="text-center mt-3"
    ></div>
  </DialogContent>
  <DialogFooter>
    <UiButton class="w-full" primary large @click="handleClick">
      Okay
    </UiButton>
  </DialogFooter>
</template>

<script setup lang="ts">
import { Icon, UiButton } from '@dacr/ui'
import DialogContent from '@/shared/dialogs/DialogContent.vue'
import DialogFooter from '@/shared/dialogs/DialogFooter.vue'
import { useDialog } from '@/shared/dialogs/useDialog'
import { sanitizeHtml } from '@/shared/utils/sanitize'
import { computed } from 'vue'

const props = defineProps<{
  title: string
  html?: string
  preventClose?: boolean
}>()

const { close, triggerEvent } = useDialog()

const sanitizedHtml = computed(() =>
  props.html ? sanitizeHtml(props.html) : ''
)

const handleClick = () => {
  const triggered = triggerEvent('success')

  if (!triggered) {
    close()
  }
}
</script>
